<template>
  <div
    class="f-cover flex-c text-center bg-black-85"
    :class="[phone ? 'pl-12' : 'pl-56']"
  >
    <div class="max-w-3xl px-12">
      <h1 class="text-white font-medium text-xl md:text-3xl mb-16">
        {{ copy }}
      </h1>
      <Button
        :path="path"
        text="Let's go"
        icon="ArrowIcon"
        class="btn btn-secondary py-3 px-8 w-40 font-bold flex justify-between mx-auto"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Button from '@/components/buttons/Button.vue'

export default {
  name: 'InstructionOverlay',

  components: {
    Button
  },

  props: {
    isCampusIntro: {
      type: Boolean,
      default: false
    },
    isGuidedIntro: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState(['touch', 'mobile', 'phone']),
    ...mapGetters(['guidedtour']),

    path() {
      const guidedTourPath = this.guidedtour?.children[0].slug || ''
      if (this.isGuidedIntro) {
        return {
          name: 'guided-panorama',
          params: { panorama_id: guidedTourPath }
        }
      } else {
        return {
          name: 'campus-category',
          params: { category_id: 'explore-all' }
        }
      }
    },

    copy() {
      return this.isGuidedIntro
        ? 'Let us show you the highlights'
        : 'Use the sidebar to filter content and explore facilities by clicking on the map pins'
    }
  }
}
</script>
